var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_544_20976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.204102,
    y: 0.239746,
    width: 19.5607,
    height: 19.5607,
    fill: "#92498E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_544_20976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0485 16.9477C14.5125 16.9477 12.9694 16.5906 11.4193 15.8764C9.86917 15.1622 8.44366 14.1547 7.14275 12.8538C5.84707 11.5529 4.84213 10.1287 4.12793 8.58118C3.41374 7.03367 3.05664 5.49191 3.05664 3.95591C3.05664 3.7114 3.13814 3.50634 3.30115 3.34073C3.46416 3.1751 3.66791 3.09229 3.91242 3.09229H6.57064C6.77649 3.09229 6.95804 3.15942 7.1153 3.2937C7.27256 3.42798 7.37261 3.59385 7.41544 3.79134L7.88251 6.18938C7.91491 6.41195 7.90811 6.60317 7.86213 6.76303C7.81617 6.9229 7.73362 7.05717 7.61449 7.16584L5.7321 8.99809C6.03512 9.55293 6.38125 10.0777 6.77048 10.5725C7.15971 11.0673 7.58107 11.5398 8.03455 11.9902C8.48179 12.4374 8.95723 12.8528 9.46087 13.2363C9.96452 13.6197 10.5084 13.9766 11.0925 14.3068L12.9216 12.462C13.0491 12.3293 13.2035 12.2363 13.3848 12.183C13.5661 12.1297 13.7544 12.1166 13.9498 12.1438L16.213 12.6046C16.4189 12.6589 16.5869 12.764 16.717 12.9196C16.847 13.0753 16.9121 13.2519 16.9121 13.4494V16.092C16.9121 16.3365 16.8293 16.5402 16.6637 16.7032C16.498 16.8662 16.293 16.9477 16.0485 16.9477Z",
    fill: "#6842D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e9fe470a7ffac6d7ffb0448c1fbe5cf7.svg";
export { ForwardRef as ReactComponent };